module.exports = __webpack_public_path__ + "img/ascend_gold29.2bc5664b.png";